/**
 * Detects the benign "ResizeObserver loop" browser warning that fires when a
 * ResizeObserver callback triggers layout changes producing additional resize
 * observations that cannot be delivered in the same animation frame.
 *
 * Covers both Chrome ("undelivered notifications") and Firefox ("limit reached")
 * message variants.
 */
export const isResizeObserverLoopError = (
  message: string | undefined,
): boolean => {
  if (!message) {
    return false;
  }
  const normalized = message.toLowerCase();
  return (
    normalized.includes("resizeobserver loop") &&
    (normalized.includes("undelivered notifications") ||
      normalized.includes("limit reached") ||
      normalized.includes("limit exceeded"))
  );
};
